import axios from 'axios';

// Teams axios instance (similar to axiosInstance5 for Slack)
const axiosInstanceTeams = process.env.NODE_ENV === 'production' ? axios.create({
  baseURL: 'https://msteamsgames.ricotta.team/'
}) : 
axios.create({
  baseURL: 'http://localhost:8080/'
});

export default axiosInstanceTeams;
